import { useEffect } from "react";

// Lightweight per-page SEO hook. No dependency on react-helmet — just imperatively
// manages <title>, meta description, and canonical link on mount/update.
//
// Usage:
//   useSEO({
//     title: "Pricing – Hearth & Crate",
//     description: "£29/mo or £290/yr…",
//     canonical: "https://hearthpro.co.uk/pricing",
//   });
export function useSEO({ title, description, canonical } = {}) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description);
    }
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
  }, [title, description, canonical]);
}
